import { render } from "./profileImage.vue?vue&type=template&id=c47dbda0&scoped=true&ts=true"
import script from "./profileImage.vue?vue&type=script&lang=ts"
export * from "./profileImage.vue?vue&type=script&lang=ts"

import "./profileImage.vue?vue&type=style&index=0&id=c47dbda0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47dbda0"]])

export default __exports__